(function () {
  const config = window.countryPricingGuardConfig || {};
  const correctionEnabled = Boolean(config.correctionEnabled);
  const useUsForUnmatchedTimezones = Boolean(config.useUsForUnmatchedTimezones);
  const debugEnabled = Boolean(config.debugEnabled);
  const currentCountry = config.currentCountry || '';
  const timezoneCountryMapText = config.timezoneCountryMapText || '{}';
  const isDesignMode = (window.Shopify && window.Shopify.designMode) || Boolean(config.isDesignMode);
  const analyticsEventKey = 'country-pricing-guard:pending-ga-event';
  const analyticsEventName = 'country_correction_applied';

  function debugLog(message, data) {
    if (!debugEnabled) return;
    if (data === undefined) {
      console.log('[Country Pricing Guard]', message);
      return;
    }
    console.log('[Country Pricing Guard]', message, data);
  }

  function getStoredAnalyticsEvent() {
    try {
      const eventText = window.sessionStorage.getItem(analyticsEventKey);
      return eventText ? JSON.parse(eventText) : null;
    } catch (error) {
      debugLog('stored analytics event read failed', {
        error: error && error.message ? error.message : error
      });
      return null;
    }
  }

  function clearStoredAnalyticsEvent() {
    try {
      window.sessionStorage.removeItem(analyticsEventKey);
    } catch (error) {
      debugLog('stored analytics event clear failed', {
        error: error && error.message ? error.message : error
      });
    }
  }

  function sendStoredAnalyticsEvent(attempt) {
    const analyticsEvent = getStoredAnalyticsEvent();
    if (!analyticsEvent) return;

    if (typeof window.gtag === 'function') {
      window.gtag('event', analyticsEventName, analyticsEvent);
      clearStoredAnalyticsEvent();
      debugLog('analytics event sent', {
        eventName: analyticsEventName,
        eventParams: analyticsEvent
      });
      return;
    }

    if (attempt >= 20) {
      debugLog('analytics event skipped because gtag was unavailable', {
        eventName: analyticsEventName,
        eventParams: analyticsEvent
      });
      return;
    }

    window.setTimeout(function () {
      sendStoredAnalyticsEvent(attempt + 1);
    }, 250);
  }

  function storeAnalyticsEvent(payload) {
    try {
      window.sessionStorage.setItem(analyticsEventKey, JSON.stringify(payload));
      debugLog('analytics event stored for next page', payload);
    } catch (error) {
      debugLog('analytics event store failed', {
        error: error && error.message ? error.message : error
      });
    }
  }

  sendStoredAnalyticsEvent(0);

  debugLog('guard started', {
    correctionEnabled: correctionEnabled,
    useUsForUnmatchedTimezones: useUsForUnmatchedTimezones,
    currentCountry: currentCountry,
    isDesignMode: isDesignMode
  });

  if (!correctionEnabled) {
    debugLog('skipped because correction is disabled');
    return;
  }

  if (!currentCountry) {
    debugLog('skipped because current Shopify country is missing');
    return;
  }

  if (isDesignMode) {
    debugLog('skipped because Theme Editor/design mode is active');
    return;
  }

  let timezone = '';
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    debugLog('timezone detected', { timezone: timezone });
  } catch (error) {
    debugLog('timezone detection failed', { error: error && error.message ? error.message : error });
    return;
  }

  if (!timezone) {
    debugLog('skipped because browser timezone is empty');
    return;
  }

  let timezoneCountryMap = {};
  try {
    timezoneCountryMap = JSON.parse(timezoneCountryMapText || '{}');
    debugLog('timezone country map parsed', {
      countryCodes: Object.keys(timezoneCountryMap)
    });
  } catch (error) {
    debugLog('timezone country map JSON parse failed', {
      error: error && error.message ? error.message : error
    });
    return;
  }

  let matchedCountry = '';
  Object.keys(timezoneCountryMap).some(function (countryCode) {
    const countryTimezones = timezoneCountryMap[countryCode];
    if (!Array.isArray(countryTimezones) || countryTimezones.indexOf(timezone) === -1) return false;
    matchedCountry = countryCode.toUpperCase();
    return true;
  });

  if (!matchedCountry) {
    if (!useUsForUnmatchedTimezones) {
      debugLog('skipped because no country matched the browser timezone and US fallback is disabled', {
        timezone: timezone
      });
      return;
    }

    matchedCountry = 'US';
    debugLog('using US fallback because no country matched the browser timezone', {
      timezone: timezone
    });
  }

  if (matchedCountry === currentCountry) {
    debugLog('skipped because matched country equals current country', {
      matchedCountry: matchedCountry,
      currentCountry: currentCountry
    });
    return;
  }

  const redirectKey = [
    'country-correction',
    window.location.pathname,
    currentCountry,
    matchedCountry,
    timezone
  ].join(':');

  try {
    if (window.sessionStorage.getItem(redirectKey)) {
      debugLog('redirect skipped due to session loop guard', {
        redirectKey: redirectKey
      });
      return;
    }
    window.sessionStorage.setItem(redirectKey, '1');
  } catch (error) {
    // Continue without loop protection if storage is unavailable.
    debugLog('session loop guard unavailable; continuing without storage', {
      error: error && error.message ? error.message : error
    });
  }

  const correctedUrl = new URL(window.location.href);
  correctedUrl.searchParams.set('country', matchedCountry);
  storeAnalyticsEvent({
    original_country: currentCountry,
    corrected_country: matchedCountry,
    browser_timezone: timezone,
    original_path: window.location.pathname,
    original_search: window.location.search,
    corrected_url: correctedUrl.toString()
  });
  debugLog('redirecting to corrected country', {
    fromCountry: currentCountry,
    toCountry: matchedCountry,
    timezone: timezone,
    url: correctedUrl.toString()
  });
  window.location.replace(correctedUrl.toString());
})();
